import React from 'react';

import SvgContainer from '../SvgContainer';

const Cloud = () => {
    return (
        <SvgContainer>
            <path d="M12.9 6.775C12.4467 4.61875 10.4267 3 8 3C6.07333 3 4.4 4.025 3.56667 5.525C1.56 5.725 0 7.31875 0 9.25C0 11.3188 1.79333 13 4 13H12.6667C14.5067 13 16 11.6 16 9.875C16 8.225 14.6333 6.8875 12.9 6.775ZM10.0689 8.625C10.5222 8.625 10.7416 9.17976 10.4109 9.48977L8.34197 11.4294C8.14964 11.6097 7.85036 11.6097 7.65803 11.4294L5.58909 9.48977C5.25841 9.17976 5.47779 8.625 5.93106 8.625H6.66667V6.625C6.66667 6.34886 6.89052 6.125 7.16667 6.125H8.83333C9.10948 6.125 9.33333 6.34886 9.33333 6.625V8.625H10.0689Z" />
        </SvgContainer>
    );
};

export default Cloud;
